import React from "react";
import ShowValidationMessages from "../components/ShowValidationMessages";
import ShowValidationMessagesApplicant from "../components/ShowValidationMessagesApplicant";

type Props = {
  role?: string;
  validationMessages?: Record<string, any[]>;
  sourceId: number;
  trnId?: any;
};

const ArgylePayrollValidationMessages = ({
  role,
  validationMessages,
  sourceId,
  trnId,
}: Props) => {
  const sourceMessages = validationMessages?.[`source_${sourceId}`] || [];
  const subscriberMessages = sourceMessages
    .map((item) => item?.admin)
    .filter(
      (item) =>
        item?.message &&
        (role === "Docuverus Super Admin" || !item?.isDeleted)
    );
  const applicantMessages = sourceMessages
    .map((item) => item?.applicant)
    .filter(
      (item) =>
        item?.message &&
        (role === "Docuverus Super Admin" || !item?.isDeleted)
    );

  if (role === "applicant") {
    return (
      <ShowValidationMessagesApplicant
        validation_message={applicantMessages}
      />
    );
  }

  return (
    <>
      <ShowValidationMessages
        role={role}
        validation_message={subscriberMessages}
        trn_id={trnId}
        source_id={sourceId}
        section="Employment"
        invalidateQueries="argylePayrollIncomeValidationCheck"
        tag="updateValidationMessages_employment"
        document_id={3}
        source_type="argyle_payroll"
      />
      <ShowValidationMessages
        role={role}
        validation_message={applicantMessages}
        isApplicantTitle={true}
        trn_id={trnId}
        source_id={sourceId}
        section="Employment"
        invalidateQueries="argylePayrollIncomeValidationCheck"
        tag="updateValidationMessages_employment"
        document_id={3}
        source_type="argyle_payroll"
      />
    </>
  );
};

export default ArgylePayrollValidationMessages;
